import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { getUserProperties } from '../../users/src/core/api';
import { queryClient } from '../core/queryClient';

export type UserPropertiesResult = Awaited<ReturnType<typeof getUserProperties>>;
type UserPropertiesQueryOptions = Omit<QueryObserverOptions<UserPropertiesResult>, 'queryKey' | 'queryFn'>;

const USER_PROPERTIES_STALE_TIME = 300_000;

export const userPropertiesQueryKey = () => ['current-user', 'properties'] as const;

const userPropertiesQueryOptions = () => ({
  gcTime: Infinity,
  queryFn: () => getUserProperties(),
  queryKey: userPropertiesQueryKey(),
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  retry: false as const,
  staleTime: USER_PROPERTIES_STALE_TIME
});

export const clearUserPropertiesQueryCache = (refetchType: 'active' | 'none' = 'active'): Promise<void> =>
  queryClient.invalidateQueries({ exact: true, queryKey: userPropertiesQueryKey(), refetchType });

export const ensureUserPropertiesData = (): Promise<UserPropertiesResult> =>
  queryClient.fetchQuery(userPropertiesQueryOptions());

export const userPropertiesQuery = (options?: UserPropertiesQueryOptions): QueryObserver<UserPropertiesResult> =>
  new QueryObserver<UserPropertiesResult>(queryClient, {
    ...userPropertiesQueryOptions(),
    ...options
  });
